module.exports = __webpack_public_path__ + "img/yuyan1.253a7834.png";